(function () {
  'use strict';

  function initAllSections() {
    const sections = document.querySelectorAll('[id^="category-detail-grid-"]');
    sections.forEach(initSection);
  }

  function initSection(root) {
    if (!root || root.dataset.cdgInited === 'true') return;
    root.dataset.cdgInited = 'true';

    const nav = root.querySelector('.cdg-nav');
    const grid = root.querySelector('.cdg-grid');
    root.querySelectorAll('.cdg-nav-item').forEach(function (li, idx) {
      const btn = li.querySelector('.cdg-nav-btn');
      const subUl = li.querySelector('.cdg-nav-level2');
      if (subUl) {
        if (!subUl.id) subUl.id = (root.id || 'cdg') + '-sublist-' + idx;
        if (btn) btn.setAttribute('aria-controls', subUl.id);
        if (!btn.hasAttribute('aria-expanded')) btn.setAttribute('aria-expanded', 'false');
        if (!subUl.hasAttribute('aria-hidden')) subUl.setAttribute('aria-hidden', 'true');
      } else {
        if (btn && !btn.hasAttribute('aria-expanded')) btn.setAttribute('aria-expanded', 'false');
      }
    });

    if (nav) {
      nav.addEventListener('click', function (e) {
        const level1Btn = e.target.closest('.cdg-level1-btn');
        if (level1Btn) {
          const parent = level1Btn.closest('.cdg-nav-item');
          const subUl = parent && parent.querySelector('.cdg-nav-level2');
          if (!subUl) return;
          const isOpen = subUl.getAttribute('aria-hidden') === 'false';
          subUl.setAttribute('aria-hidden', isOpen ? 'true' : 'false');
          level1Btn.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
          level1Btn.classList.toggle('is-open', !isOpen);
          return;
        }
        const subLink = e.target.closest('.cdg-sublink');
        if (subLink) {
          e.preventDefault();
          const handle = subLink.getAttribute('data-cdg-subhandle');
          if (handle) showCategory(handle);
          else showCategory('');
        }
      });

      nav.addEventListener('keydown', function (e) {
        const targetBtn = e.target.closest('.cdg-level1-btn, .cdg-sublink');
        if (!targetBtn) return;
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          targetBtn.click();
        }
      });
    }

    function showCategory(handle) {
      root.querySelectorAll('.cdg-sublink.active').forEach(function (a) {
        a.classList.remove('active');
      });
      const targetLink = root.querySelector('.cdg-sublink[data-cdg-subhandle="' + handle + '"]');
      if (targetLink) targetLink.classList.add('active');

      const target = (handle || '').toString().toLowerCase();
      const cards = Array.from(root.querySelectorAll('.cdg-card'));
      cards.forEach(function (card) {
        const cat = (card.getAttribute('data-cdg-category') || '').toLowerCase();
        if (!target) {
          card.classList.remove('cdg-hidden');
        } else {
          if (cat === target) card.classList.remove('cdg-hidden');
          else card.classList.add('cdg-hidden');
        }
      });

      const newHash = handle ? `#${handle}` : '';
      if (window.location.hash !== newHash) {
        history.replaceState(null, document.title, window.location.pathname + newHash);
      }

      const mobileWrap = root.querySelector('.cdg-mobile-filters');
      if (mobileWrap) {
        const lvl2 = mobileWrap.querySelector('[data-cdg-mobile="level2"]');
        if (lvl2) {
          const opt = lvl2.querySelector('[data-value="' + handle + '"]');
          if (opt) {
            lvl2.querySelectorAll('[data-value]').forEach((o) => o.classList.remove('selected'));
            opt.classList.add('selected');
            const valText = opt.textContent || '';
            const toggle = mobileWrap.querySelector('[data-cdg-mobile-toggle="level2"] .cdg-dropdown-value');
            if (toggle) toggle.textContent = valText;
          } else {
            const toggle = mobileWrap.querySelector('[data-cdg-mobile-toggle="level2"] .cdg-dropdown-value');
            if (toggle) toggle.textContent = '';
          }
        }
      }
    }

    (function initDefaultSelection() {
      const hasHash = !!window.location.hash.trim();
      if (hasHash) return;

      const firstSubUl = root.querySelector('.cdg-nav-level2');
      if (firstSubUl) {
        firstSubUl.setAttribute('aria-hidden', 'false');
        const parentLi = firstSubUl.closest('.cdg-nav-item');
        if (parentLi) {
          const btn = parentLi.querySelector('.cdg-nav-btn');
          if (btn) {
            btn.setAttribute('aria-expanded', 'true');
            btn.classList.add('is-open');
          }
        }
        const firstSub = firstSubUl.querySelector('.cdg-sublink');
        if (firstSub) {
          showCategory(firstSub.getAttribute('data-cdg-subhandle'));
          return;
        }
      }
      const fallback = root.querySelector('.cdg-sublink');
      if (fallback) showCategory(fallback.getAttribute('data-cdg-subhandle'));
      else showCategory('');
    })();

    function buildMobileDropdowns() {
      if (!root) return;
      if (root.querySelector('.cdg-mobile-filters')) return;

      const side = root.querySelector('.cdg-side');
      if (!side) return;

      const wrap = document.createElement('div');
      wrap.className = 'cdg-mobile-filters';
      wrap.setAttribute('data-mobile-filters', 'true');

      function createDropdown(idPrefix, datasetKey) {
        const container = document.createElement('div');
        container.className = 'cdg-dropdown';
        container.setAttribute('tabindex', '0');
        container.setAttribute('role', 'combobox');
        container.setAttribute('aria-haspopup', 'listbox');
        container.setAttribute('aria-expanded', 'false');

        const toggle = document.createElement('button');
        toggle.type = 'button';
        toggle.className = 'cdg-dropdown-toggle';
        toggle.setAttribute('aria-labelledby', idPrefix + '-value');
        toggle.setAttribute('data-cdg-mobile-toggle', datasetKey);

        const valueSpan = document.createElement('span');
        valueSpan.className = 'cdg-dropdown-value';
        valueSpan.id = idPrefix + '-value';
        valueSpan.textContent = '';

        const caret = document.createElement('span');
        caret.className = 'cdg-dropdown-caret';
        caret.innerHTML =
          '<svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true"><path d="M6 9l6 6 6-6" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';

        toggle.appendChild(valueSpan);
        toggle.appendChild(caret);

        const menu = document.createElement('ul');
        menu.className = 'cdg-dropdown-menu';
        menu.setAttribute('role', 'listbox');

        container.appendChild(toggle);
        container.appendChild(menu);

        container.dataset.cdgKey = datasetKey;
        return { container, toggle, menu, valueSpan };
      }

      const dd1 = createDropdown(root.id + '-mobile-lvl1', 'level1');
      const dd2 = createDropdown(root.id + '-mobile-lvl2', 'level2');

      const items = Array.from(root.querySelectorAll('.cdg-nav-item'));
      dd1.menu.innerHTML = ''; 
      items.forEach(function (li) {
        const titleSpan = li.querySelector('.cdg-nav-title');
        const handle =
          li.getAttribute('data-cdg-handle') ||
          (titleSpan ? (titleSpan.textContent || '').trim().toLowerCase().replace(/\s+/g, '-') : '');
        const text = titleSpan ? titleSpan.textContent.trim() : (li.textContent || '').trim();
        const opt = document.createElement('li');
        opt.className = 'cdg-dropdown-option';
        opt.setAttribute('role', 'option');
        opt.dataset.value = handle || '';
        opt.textContent = text || '';
        dd1.menu.appendChild(opt);
      });

      const firstOpt1 = dd1.menu.querySelector('.cdg-dropdown-option');
      if (firstOpt1) {
        setDropdownSelected(dd1, firstOpt1);
      }

      dd2.menu.innerHTML = '';
      dd2.toggle.querySelector('.cdg-dropdown-value').textContent = '';
      dd2.toggle.disabled = true;

      wrap.appendChild(dd1.container);
      wrap.appendChild(dd2.container);

      const cdgBack = side.querySelector('.cdg-back');
      if (cdgBack) {
        cdgBack.after(wrap);
      } else {
        side.insertBefore(wrap, side.firstChild);
      }

      function openDropdown(dd) {
        if (!dd) return;
        dd.container.classList.add('is-open');
        dd.container.setAttribute('aria-expanded', 'true');
        const first = dd.menu.querySelector('.cdg-dropdown-option');
        if (first) {
          dd.menu.querySelectorAll('.cdg-dropdown-option').forEach((o) => o.classList.remove('is-active'));
          first.classList.add('is-active');
          first.scrollIntoView({ block: 'nearest' });
        }
      }

      function closeDropdown(dd) {
        if (!dd) return;
        dd.container.classList.remove('is-open');
        dd.container.setAttribute('aria-expanded', 'false');
        dd.menu.querySelectorAll('.cdg-dropdown-option').forEach((o) => o.classList.remove('is-active'));
      }

      function closeAllDropdowns() {
        [dd1, dd2].forEach(closeDropdown);
      }

      function populateLevel2ByHandle(l1Handle, autoSelectFirst) {
        dd2.menu.innerHTML = '';

        const li = root.querySelector('.cdg-nav-item[data-cdg-handle="' + l1Handle + '"]');
        if (!li) {
          dd2.toggle.querySelector('.cdg-dropdown-value').textContent = '';
          dd2.toggle.disabled = true;
          return;
        }

        const children = Array.from(li.querySelectorAll('.cdg-sublink'));
        if (children.length === 0) {
          dd2.toggle.querySelector('.cdg-dropdown-value').textContent = '';
          dd2.toggle.disabled = true;
          return;
        }

        children.forEach(function (a) {
          const chHandle = a.getAttribute('data-cdg-subhandle') || '';
          const chText = (a.textContent || '').trim();
          const opt = document.createElement('li');
          opt.className = 'cdg-dropdown-option';
          opt.setAttribute('role', 'option');
          opt.dataset.value = chHandle;
          opt.textContent = chText || '';
          dd2.menu.appendChild(opt);
        });

        dd2.toggle.disabled = false;

        if (autoSelectFirst) {
          const first = dd2.menu.querySelector('.cdg-dropdown-option[data-value]');
          if (first) {
            setDropdownSelected(dd2, first);
            showCategory(first.dataset.value);
          } else {
            dd2.toggle.querySelector('.cdg-dropdown-value').textContent = '';
            showCategory('');
          }
        } else {
          dd2.toggle.querySelector('.cdg-dropdown-value').textContent = '';
        }
      }

      function setDropdownSelected(dd, opt) {
        if (!dd || !opt) return;
        dd.menu.querySelectorAll('.cdg-dropdown-option').forEach((o) => o.classList.remove('selected'));
        opt.classList.add('selected');
        dd.toggle.querySelector('.cdg-dropdown-value').textContent = opt.textContent || '';
        dd.menu.querySelectorAll('.cdg-dropdown-option').forEach((o) => o.classList.remove('is-active'));
        opt.classList.add('is-active');
      }

      function onMenuClick(e, dd) {
        const opt = e.target.closest('.cdg-dropdown-option');
        if (!opt) return;
        e.preventDefault();
        setDropdownSelected(dd, opt);
        closeDropdown(dd);

        if (dd === dd1) {
          const l1Handle = opt.dataset.value || '';
          populateLevel2ByHandle(l1Handle, true);
        } else if (dd === dd2) {
          const handle = opt.dataset.value || '';
          if (!handle) showCategory('');
          else showCategory(handle);
        }
      }

      dd1.menu.addEventListener('click', function (e) {
        onMenuClick(e, dd1);
      });
      dd2.menu.addEventListener('click', function (e) {
        onMenuClick(e, dd2);
      });

      dd1.toggle.addEventListener('click', function () {
        const isOpen = dd1.container.classList.contains('is-open');
        if (isOpen) closeDropdown(dd1);
        else openDropdown(dd1);
      });

      dd2.toggle.addEventListener('click', function () {
        if (dd2.toggle.disabled) return;
        const isOpen = dd2.container.classList.contains('is-open');
        if (isOpen) closeDropdown(dd2);
        else openDropdown(dd2);
      });

      [dd1.container, dd2.container].forEach(function (dd) {
        dd.addEventListener('keydown', function (e) {
          const menu = dd.querySelector('.cdg-dropdown-menu');
          const opts = Array.from(menu.querySelectorAll('.cdg-dropdown-option'));
          const activeIdx = opts.findIndex((o) => o.classList.contains('is-active'));

          if (e.key === 'ArrowDown') {
            e.preventDefault();
            if (!dd.classList.contains('is-open')) {
              dd.classList.add('is-open');
              dd.setAttribute('aria-expanded', 'true');
              if (opts[0]) opts[0].classList.add('is-active');
              return;
            }
            const next = opts[Math.min(opts.length - 1, Math.max(0, activeIdx + 1))];
            if (next) {
              opts.forEach((o) => o.classList.remove('is-active'));
              next.classList.add('is-active');
              next.scrollIntoView({ block: 'nearest' });
            }
          } else if (e.key === 'ArrowUp') {
            e.preventDefault();
            if (!dd.classList.contains('is-open')) {
              dd.classList.add('is-open');
              dd.setAttribute('aria-expanded', 'true');
              if (opts[opts.length - 1]) opts[opts.length - 1].classList.add('is-active');
              return;
            }
            const prev = opts[Math.max(0, activeIdx - 1)];
            if (prev) {
              opts.forEach((o) => o.classList.remove('is-active'));
              prev.classList.add('is-active');
              prev.scrollIntoView({ block: 'nearest' });
            }
          } else if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            if (!dd.classList.contains('is-open')) {
              dd.classList.add('is-open');
              dd.setAttribute('aria-expanded', 'true');
              return;
            }
            const active = menu.querySelector('.cdg-dropdown-option.is-active') || opts[0];
            if (active) active.click();
          } else if (e.key === 'Escape') {
            e.preventDefault();
            closeAllDropdowns();
          }
        });
      });

      document.addEventListener(
        'click',
        function (e) {
          if (!wrap.contains(e.target)) closeAllDropdowns();
        },
        { passive: true }
      );

      const active = root.querySelector('.cdg-sublink.active');
      if (active) {
        const parentLi = active.closest('.cdg-nav-item');
        if (parentLi) {
          const parentHandle = parentLi.getAttribute('data-cdg-handle') || '';
          const opt1 = dd1.menu.querySelector('.cdg-dropdown-option[data-value="' + parentHandle + '"]');
          if (opt1) {
            setDropdownSelected(dd1, opt1);
          } else if (dd1.menu.querySelector('.cdg-dropdown-option')) {
            setDropdownSelected(dd1, dd1.menu.querySelector('.cdg-dropdown-option'));
          }

          populateLevel2ByHandle(parentHandle, false);
          const subHandle = active.getAttribute('data-cdg-subhandle') || '';
          const opt2 = dd2.menu.querySelector('.cdg-dropdown-option[data-value="' + subHandle + '"]');
          if (opt2) {
            setDropdownSelected(dd2, opt2);
          } else if (dd2.menu.querySelector('.cdg-dropdown-option')) {
            setDropdownSelected(dd2, dd2.menu.querySelector('.cdg-dropdown-option'));
          }
        }
      } else {
        if (dd1.menu.querySelector('.cdg-dropdown-option')) {
          setDropdownSelected(dd1, dd1.menu.querySelector('.cdg-dropdown-option'));
          const firstHandle = dd1.menu.querySelector('.cdg-dropdown-option').dataset.value || '';
          populateLevel2ByHandle(firstHandle, true);
        }
      }

      wrap.setAttribute('data-mobile-wrap-id', root.id + '-mobilewrap');
    }

    function ensureMobile() {
      if (window.innerWidth <= 768) buildMobileDropdowns();
    }
    ensureMobile();
    window.addEventListener('resize', function () {
      if (window.innerWidth <= 768) buildMobileDropdowns();
    });

    if (grid) {
      const mo = new MutationObserver(function () {
        const active = root.querySelector('.cdg-sublink.active');
        showCategory(active ? active.getAttribute('data-cdg-subhandle') : '');
      });
      mo.observe(grid, { childList: true, subtree: false });
    }

    (function ensureHiddenClass() {
      if (!document.querySelector('style[data-cdg-hidden]')) {
        const style = document.createElement('style');
        style.setAttribute('data-cdg-hidden', 'true');
        style.innerHTML =
          '.cdg-hidden{display:none !important;} .cdg-nav-btn.is-open .cdg-caret{transform:rotate(180deg);} .cdg-caret{transition:transform .18s ease;}';
        document.head.appendChild(style);
      }
    })();

    function initFromHash() {
      const currentHash = decodeURIComponent(window.location.hash.slice(1)).toLowerCase();
      if (!currentHash) return;

      const targetSubLink = root.querySelector(`.cdg-sublink[data-cdg-subhandle="${currentHash}"]`);
      if (targetSubLink) {
        showCategory(currentHash);

        const parentLi = targetSubLink.closest('.cdg-nav-item');
        const level1Btn = parentLi.querySelector('.cdg-level1-btn');
        const subUl = parentLi.querySelector('.cdg-nav-level2');
        if (level1Btn && subUl) {
          level1Btn.setAttribute('aria-expanded', 'true');
          level1Btn.classList.add('is-open');
          subUl.setAttribute('aria-hidden', 'false');
        }

        const mobileWrap = root.querySelector('.cdg-mobile-filters');
        if (mobileWrap) {
          const parentHandle = parentLi.getAttribute('data-cdg-handle');
          const lvl1Opt = mobileWrap.querySelector(`.cdg-dropdown-option[data-value="${parentHandle}"]`);
          if (lvl1Opt) {
            const dd1 = {
              menu: mobileWrap.querySelector('[data-cdg-mobile="level1"] .cdg-dropdown-menu'),
              toggle: mobileWrap.querySelector('[data-cdg-mobile="level1"] .cdg-dropdown-toggle')
            };
            setDropdownSelected(dd1, lvl1Opt);
            populateLevel2ByHandle(parentHandle, false);

            const lvl2Opt = mobileWrap.querySelector(`[data-cdg-mobile="level2"] .cdg-dropdown-option[data-value="${currentHash}"]`);
            if (lvl2Opt) {
              const dd2 = {
                menu: mobileWrap.querySelector('[data-cdg-mobile="level2"] .cdg-dropdown-menu'),
                toggle: mobileWrap.querySelector('[data-cdg-mobile="level2"] .cdg-dropdown-toggle')
              };
              setDropdownSelected(dd2, lvl2Opt);
            }
          }
        }
      } else {
        showCategory('');
      }
    }

    initFromHash();
    window.addEventListener('hashchange', initFromHash);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllSections);
  } else {
    initAllSections();
  }
})();
